// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
import GlobalStyles from '../../../config/styles';

const styles = () => ({
  // Sub-heading for the screen, now that it sits inside the account shell
  // rather than carrying its own PaperLayout title.
  screenTitle: {
    margin: '16px 0 0 0',
    textAlign: 'center',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    color: GlobalStyles.color.COLOR_GRAY,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    // margin auto centres the fixed-width column. PaperLayout used to do this
    // for us; inside the account shell the column has to centre itself, or it
    // sits against the left edge of a much wider panel.
    width: '290px',
    margin: '0 auto',
    padding: '8px 0 32px 0',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  descContainer: {
    margin: '20px 0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  desc: {
    margin: 0,
    textAlign: 'center',
    color: GlobalStyles.color.COLOR_SECONDARY,
  }
});

export default styles;
